// Tenant row type + platform-default fallback.
//
// Mirrors the public.tenants columns (PR #5 schema). Kept hand-written
// rather than imported from packages/shared/src/database.types.ts so
// the type isn't tied to a regen cadence — when a tenants column moves,
// this file is the one place to update.

export type Tenant = {
  id: string;
  name: string;
  slug: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};

// Returned by useTenant() in two cases:
//   1. The user is a platform_admin (no tenant_id claim by design).
//   2. /api/tenant errored. We surface the failure via status='error'
//      AND fall through to PLATFORM_DEFAULT so callers that read
//      `tenant.name` etc. don't have to null-check on every render.
//
// Choosing a sentinel UUID of all zeros is intentional: any RLS policy
// that compares against this id will fail closed (no rows match),
// which is what we want when tenant resolution failed.
export const PLATFORM_DEFAULT: Tenant = {
  id: '00000000-0000-0000-0000-000000000000',
  name: 'LYN Rx',
  slug: 'platform',
  created_at: '1970-01-01T00:00:00.000Z',
  updated_at: '1970-01-01T00:00:00.000Z',
  deleted_at: null,
};
